import React, { useEffect, useRef, useState } from 'react';
import './manage-contributions.styles.scss';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import { useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPiggyBank } from '@fortawesome/free-solid-svg-icons';
import ManageContributionCard from './manage-contribution-card.component';
import { getCollectionFromDb } from '@/utils/getDataFromDb';
import { useSelector } from 'react-redux';

const ManageContributions = ({
    gameData,
    gameActivity,
    playerList,
    gameStats,
}) => {

    const screenSize = useSelector(state => state.contentData.screenSize);
    const [contributionsToDisplay, setContributionsToDisplay] = useState([]);
    const contributionsRef = useRef({});
    let contributionsListener;
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        return () => {
            if (contributionsListener) contributionsListener();
        }
    }, [])

    useEffect(() => {
        if (!gameData) return;
        getContributionsToDisplay();
    }, [gameData]);

    function getContributionsToDisplay() {
        getCollectionFromDb({
            "collection": `games/${gameData.gameId}/gameElements`,
            "query1": {
                "key": "opt_itemType",
                "condition": "==",
                "value": "contribution"
            },
            "callback": callback,
            "handleListener": handleListener
        })
        function callback(data) {
            console.log(data);
            contributionsRef.current = {
                ...contributionsRef.current,
                ...{ [data.id]: data }
            }
            setContributionsToDisplay(Object.values(contributionsRef.current));
        }
        function handleListener(data) {
            contributionsListener = data;
        }
    }

    return (
        <div className={`manage-contributions ${screenSize}`}>
            <div className='g-card contributions-card'>
                <BackButton cancel={() => navigate(`${location.pathname.includes('/preview/manager/')
                        ? '/preview/manager'
                        : '/manage'
                    }/${gameData.path}`)} />
                <div className="g-space-1"></div>
                <div className='card-title'>
                    <div className='title-with-icon'>
                        <FontAwesomeIcon icon={faPiggyBank} />Manage Contributions
                    </div>
                </div>
                <hr />
                <div className='contribution-list'>
                    {
                        (contributionsToDisplay.length > 0)
                            ?
                            contributionsToDisplay.map(c => (
                                <div
                                    key={c.id}
                                    className='contribution-card' >
                                    <ManageContributionCard
                                        gameData={gameData}
                                        item={c}
                                        gameStats={gameStats}
                                        // gameActivity={gameActivity}
                                        playerList={playerList} />
                                </div>
                            ))
                            :
                            <h3>No contributions yet...</h3>
                    }
                </div>
            </div>
        </div>
    )
}

export default ManageContributions